var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGoogleLogin } from '@react-oauth/google';
import { UserContext } from '@web/contexts/User';
import { toast } from '@web/hocs/useToast';
import { trpc } from '@web/lib/trpc';
import { classNames } from '@web/utility';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
export var SignInButtonGoogle = function (_a) {
    var className = _a.className;
    var login = useContext(UserContext).login;
    var t = useTranslation().t;
    var googleAuthMutation = trpc.googleAuth.useMutation();
    var googleLogin = useGoogleLogin({
        flow: 'auth-code',
        scope: [
            'email',
            'https://www.googleapis.com/auth/userinfo.profile',
            'https://www.googleapis.com/auth/userinfo.email'
        ].join(' '),
        onSuccess: function (codeResponse) { return __awaiter(void 0, void 0, void 0, function () {
            var code, jwt, error_1, errorData, isWorkspaceDeleting;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        code = codeResponse.code;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, googleAuthMutation.mutateAsync({
                                code: code
                            })];
                    case 2:
                        jwt = _d.sent();
                        login(jwt);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _d.sent();
                        errorData = error_1;
                        isWorkspaceDeleting = ((_a = errorData.data) === null || _a === void 0 ? void 0 : _a.code) === 'FORBIDDEN' &&
                            ((_b = errorData.message) === null || _b === void 0 ? void 0 : _b.includes('Workspace is being deleted'));
                        toast({
                            title: isWorkspaceDeleting
                                ? t('workspace.deleting.title')
                                : t('login.alert.title'),
                            description: isWorkspaceDeleting
                                ? t('workspace.deleting.signInDescription')
                                : ((_c = errorData.message) !== null && _c !== void 0 ? _c : t('login.alert.description')),
                            variant: 'error',
                            duration: 5000
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, true];
                }
            });
        }); }
    });
    return (_jsxs("div", __assign({ className: classNames('text-sm flex items-center py-3 px-5 justify-center p-2 border rounded-md cursor-pointer', className), onClick: function () { return googleLogin(); } }, { children: [_jsx("div", __assign({ className: "mr-3" }, { children: _jsx("img", { src: "assets/img/others/logoGoogle.svg", alt: "Google" }) })), _jsx("div", { children: t('login.signInGoogle') })] })));
};
